
import React from 'react';

export const APP_NAME = "Delyon";
export const PRIMARY_COLOR = "#ea580c"; // Orange 600
export const SECONDARY_COLOR = "#0f172a"; // Slate 950

export const formatCurrency = (value: number) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
};

export const getStatusBadge = (status: string) => {
  const baseClass = "text-[10px] uppercase tracking-tighter font-black px-2.5 py-1.5 rounded-md border flex items-center gap-1.5 w-fit shadow-sm";
  
  switch (status) {
    case 'novo':
      return (
        <span className={`${baseClass} bg-red-600 text-white border-red-700 animate-pulse ring-4 ring-red-100`}>
          <span className="w-1.5 h-1.5 bg-white rounded-full"></span>
          PEDIDO NOVO
        </span>
      );
    case 'aceito':
      return (
        <span className={`${baseClass} bg-emerald-50 text-emerald-700 border-emerald-200`}>
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path></svg>
          CONFIRMADO
        </span>
      );
    case 'preparo':
      return (
        <span className={`${baseClass} bg-amber-100 text-amber-800 border-amber-200`}>
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
          NA COZINHA
        </span>
      );
    case 'entrega':
      return (
        <span className={`${baseClass} bg-blue-600 text-white border-blue-700`}>
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M13 10V3L4 14h7v7l9-11h-7z"></path></svg>
          SAIU PARA ENTREGA
        </span>
      );
    case 'concluido':
      return (
        <span className={`${baseClass} bg-slate-100 text-slate-500 border-slate-200 opacity-70`}>
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
          FINALIZADO
        </span>
      );
    default:
      return <span className={baseClass}>{status}</span>;
  }
};
